var search_trigger = document.querySelector('.search-box__icon'),
    search_box = document.querySelector('.search-box__form'),
    header = document.querySelector('.header');

if (search_trigger) {
    search_trigger.addEventListener('click', function() {
        search_box.classList.toggle('search-box__form--active');
        document.getElementById('searchTerm').focus();
        header.classList.toggle('search-box--open');

        // Update aria tags
        if (search_box.getAttribute('aria-expanded') === 'true') {
            search_box.setAttribute('aria-expanded', 'false');
        } else {
            search_box.setAttribute('aria-expanded', 'true');
        }
    })
}